// // dashboard-frontend/src/components/AdminUserManagement.jsx
// import React, { useEffect, useState } from 'react';
// import { fetchJSON } from '../api';

// const AdminUserManagement = () => {
//   const [users, setUsers] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [newUser, setNewUser] = useState({
//     username: '',
//     email: '',
//     password: '',
//     role: 'volunteer'
//   });
//   const [resetPassword, setResetPassword] = useState('');

//   // Get the logged-in admin user from localStorage
//   const currentUser = JSON.parse(localStorage.getItem("dashboardUser") || "{}");

//   const fetchUsers = async () => {
//     try {
//       const data = await fetchJSON('/api/users');
//       setUsers(data);
//     } catch (err) {
//       alert(err.message);
//     }
//     setLoading(false);
//   };

//   useEffect(() => {
//     fetchUsers();
//   }, []);

//   const handleAddUser = async e => {
//     e.preventDefault();
//     try {
//       const data = await fetchJSON('/api/users/register', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(newUser)
//       });
//       alert(`User "${data.username}" added successfully!`);
//       setNewUser({ username: '', email: '', password: '', role: 'volunteer' });
//       fetchUsers();
//     } catch (err) {
//       alert(err.message);
//     }
//   };

//   const handleDeleteUser = async userId => {
//     if (!window.confirm('Are you sure you want to delete this user?')) return;
//     try {
//       await fetchJSON(`/api/users/${userId}`, { method: 'DELETE' });
//       alert('User removed');
//       fetchUsers();
//     } catch (err) {
//       alert(err.message);
//     }
//   };

//   const handleResetPassword = async userId => {
//     if (!resetPassword) {
//       alert('Enter new password before resetting!');
//       return;
//     }
//     try {
//       await fetchJSON(`/api/users/${userId}`, {
//         method: 'PUT',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ newPassword: resetPassword, reset: true })
//       });
//       alert('Password reset successful');
//       setResetPassword('');
//       fetchUsers();
//     } catch (err) {
//       alert(err.message);
//     }
//   };

//   return (
//     <div className="p-4">
//       <h2 className="text-2xl font-bold mb-4">User Management</h2>

//       {/* Show Add User form only if current user is master_admin */}
//       {currentUser.role === 'master_admin' && (
//         <form onSubmit={handleAddUser} className="mb-6">
//           <h4 className="font-semibold mb-2">Add New User</h4>
//           <div className="mb-2">
//             <label>Username:</label>
//             <input
//               type="text"
//               value={newUser.username}
//               onChange={e => setNewUser({ ...newUser, username: e.target.value })}
//               className="border p-2 rounded w-full"
//               required
//             />
//           </div>
//           <div className="mb-2">
//             <label>Email:</label>
//             <input
//               type="email"
//               value={newUser.email}
//               onChange={e => setNewUser({ ...newUser, email: e.target.value })}
//               className="border p-2 rounded w-full"
//               required
//             />
//           </div>
//           <div className="mb-2">
//             <label>Password:</label>
//             <input
//               type="password"
//               value={newUser.password}
//               onChange={e => setNewUser({ ...newUser, password: e.target.value })}
//               className="border p-2 rounded w-full"
//               required
//             />
//           </div>
//           <div className="mb-2">
//             <label>Role:</label>
//             <select
//               value={newUser.role}
//               onChange={e => setNewUser({ ...newUser, role: e.target.value })}
//               className="border p-2 rounded w-full"
//             >
//               <option value="volunteer">Volunteer</option>
//               <option value="admin">Admin</option>
//               <option value="accounts">Accounts</option>
//               <option value="trustee">Trustee</option>
//               <option value="graphics">Graphics</option>
//               <option value="master_admin">Master Admin</option>
//             </select>
//           </div>
//           <button type="submit" className="bg-primary text-white px-4 py-2 rounded">Add User</button>
//         </form>
//       )}

//       {loading ? (
//         <p>Loading Users...</p>
//       ) : (
//         <table className="min-w-full bg-white border">
//           <thead>
//             <tr className="border-b">
//               <th className="py-2 px-4">Username</th>
//               <th className="py-2 px-4">Email</th>
//               <th className="py-2 px-4">Role</th>
//               <th className="py-2 px-4">First Time?</th>
//               <th className="py-2 px-4">Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {users.map(u => (
//               <tr key={u._id} className="border-b">
//                 <td className="py-2 px-4">{u.username}</td>
//                 <td className="py-2 px-4">{u.email}</td>
//                 <td className="py-2 px-4">{u.role}</td>
//                 <td className="py-2 px-4">{u.firstTime ? 'Yes' : 'No'}</td>
//                 <td className="py-2 px-4">
//                   {/* Only master_admin sees Delete/Reset actions */}
//                   {currentUser.role === 'master_admin' && (
//                     <>
//                       <button onClick={() => handleDeleteUser(u._id)} className="bg-red-500 text-white px-2 py-1 rounded mr-2">
//                         Delete
//                       </button>
//                       <input
//                         type="password"
//                         placeholder="New Password"
//                         value={resetPassword}
//                         onChange={e => setResetPassword(e.target.value)}
//                         className="border p-1 rounded mr-2"
//                       />
//                       <button onClick={() => handleResetPassword(u._id)} className="bg-blue-500 text-white px-2 py-1 rounded">
//                         Reset
//                       </button>
//                     </>
//                   )}
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       )}
//     </div>
//   );
// };

// export default AdminUserManagement;





// dashboard-frontend/src/components/AdminUserManagement.jsx

import React, { useEffect, useState } from 'react';
import { fetchJSON } from '../api';

const AdminUserManagement = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  // State for adding a new user
  const [newUser, setNewUser] = useState({
    username: '',
    email: '',
    password: '',
    role: 'volunteer'
  });

  // A map of userId -> newPassword (for resetting existing users' passwords)
  const [resetPasswords, setResetPasswords] = useState({});

  // Get the logged-in admin user from localStorage
  const currentUser = JSON.parse(localStorage.getItem('dashboardUser') || '{}');

  // Fetch all users
  const fetchUsers = async () => {
    try {
      const data = await fetchJSON('/api/users');
      setUsers(data);
    } catch (err) {
      alert(err.message);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  // Add new user (only master_admin can do this)
  const handleAddUser = async e => {
    e.preventDefault();
    try {
      const data = await fetchJSON('/api/users/register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newUser)
      });
      alert(`User "${data.username}" added successfully!`);
      setNewUser({ username: '', email: '', password: '', role: 'volunteer' });
      fetchUsers();
    } catch (err) {
      alert(err.message);
    }
  };

  // Delete user (only master_admin can do this)
  const handleDeleteUser = async userId => {
    if (!window.confirm('Are you sure you want to delete this user?')) return;
    try {
      await fetchJSON(`/api/users/${userId}`, { method: 'DELETE' });
      alert('User removed');
      fetchUsers();
    } catch (err) {
      alert(err.message);
    }
  };

  // Reset password for a specific user
  const handleResetPassword = async userId => {
    const newPassword = resetPasswords[userId] || '';
    if (!newPassword) {
      alert('Enter a new password before resetting!');
      return;
    }
    try {
      await fetchJSON(`/api/users/${userId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ newPassword, reset: true })
      });
      alert('Password reset successful');

      // Clear the password field for this user
      setResetPasswords(prev => {
        const updated = { ...prev };
        delete updated[userId];
        return updated;
      });

      // Refresh user list
      fetchUsers();
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <div className="p-4">
      <h2 className="text-2xl font-bold mb-4">User Management</h2>

      {/* Show Add User form only if current user is master_admin */}
      {currentUser.role === 'master_admin' && (
        <form onSubmit={handleAddUser} className="mb-6">
          <h4 className="font-semibold mb-2">Add New User</h4>
          <div className="mb-2">
            <label>Username:</label>
            <input
              type="text"
              value={newUser.username}
              onChange={e => setNewUser({ ...newUser, username: e.target.value })}
              className="border p-2 rounded w-full"
              required
            />
          </div>
          <div className="mb-2">
            <label>Email:</label>
            <input
              type="email"
              value={newUser.email}
              onChange={e => setNewUser({ ...newUser, email: e.target.value })}
              className="border p-2 rounded w-full"
              required
            />
          </div>
          <div className="mb-2">
            <label>Password:</label>
            <input
              type="password"
              value={newUser.password}
              onChange={e => setNewUser({ ...newUser, password: e.target.value })}
              className="border p-2 rounded w-full"
              required
            />
          </div>
          <div className="mb-2">
            <label>Role:</label>
            <select
              value={newUser.role}
              onChange={e => setNewUser({ ...newUser, role: e.target.value })}
              className="border p-2 rounded w-full"
            >
              <option value="volunteer">Volunteer</option>
              <option value="admin">Admin</option>
              <option value="accounts">Accounts</option>
              <option value="trustee">Trustee</option>
              <option value="graphics">Graphics</option>
              <option value="master_admin">Master Admin</option>
            </select>
          </div>
          <button type="submit" className="bg-primary text-white px-4 py-2 rounded">
            Add User
          </button>
        </form>
      )}

      {loading ? (
        <p>Loading Users...</p>
      ) : (
        <table className="min-w-full bg-white border">
          <thead>
            <tr className="border-b">
              <th className="py-2 px-4">Username</th>
              <th className="py-2 px-4">Email</th>
              <th className="py-2 px-4">Role</th>
              <th className="py-2 px-4">First Time?</th>
              <th className="py-2 px-4">Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.map(u => (
              <tr key={u._id} className="border-b">
                <td className="py-2 px-4">{u.username}</td>
                <td className="py-2 px-4">{u.email}</td>
                <td className="py-2 px-4">{u.role}</td>
                <td className="py-2 px-4">{u.firstTime ? 'Yes' : 'No'}</td>
                <td className="py-2 px-4">
                  {/* Only master_admin sees Delete/Reset actions */}
                  {currentUser.role === 'master_admin' && (
                    <>
                      <button
                        onClick={() => handleDeleteUser(u._id)}
                        className="bg-red-500 text-white px-2 py-1 rounded mr-2"
                      >
                        Delete
                      </button>

                      {/* Row-specific reset password input */}
                      <input
                        type="password"
                        placeholder="New Password"
                        value={resetPasswords[u._id] || ''}
                        onChange={e =>
                          setResetPasswords(prev => ({
                            ...prev,
                            [u._id]: e.target.value
                          }))
                        }
                        className="border p-1 rounded mr-2"
                      />

                      <button
                        onClick={() => handleResetPassword(u._id)}
                        className="bg-blue-500 text-white px-2 py-1 rounded"
                      >
                        Reset
                      </button>
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default AdminUserManagement;
